import { useState, useEffect, useRef } from "react";
import { useSelector } from "react-redux";
import { useIntl } from "react-intl";

//Components
import { DateRangePicker } from "@gpstrackit/gtc-react-controls";
import CustomSelect from 'Components/Select';
import { Grid } from "@mui/material";
import {
    SidePanel,
    Button,
    Form
} from "@gpstrackit/react-controls";;

//Actions
import { getAccounts } from 'Modules/activities/views/main/redux/saga';
import moment from "moment";

const REPORT_RETENTION_DAYS = 30;
const getRetentionMinDate = () => moment().subtract(REPORT_RETENTION_DAYS, 'days').startOf('day');

const AdvancedFilters = (props) => {
    const {
        setStartDate,
        setOpenPanel,
        setEndDate,
        setAccount,
        openPanel,
        startDate,
        tableRef,
        account,
        endDate,
    } = props;


    const { messages } = useIntl();
    const formRef = useRef();

    //Local States
    const [conditions, setConditions] = useState(tableRef?.current?.conditions || []);

    //Redux States
    const { loadingAccounts } = useSelector(state => state.activitiesMainRedux);

    const handleApply = () => {
        console.log("conditions to apply", conditions)
        tableRef?.current?.getData(null, null, null, conditions, null);
    }

    const getAccountsForSelect = (input, callback) => {
        if (!input) {
            callback([])
            return
        }
        getAccounts(input).then((response) => {
            if (response.result) {
                const { items } = response?.result
                callback(items)
            }
        })
    }

    useEffect(() => {
        if (openPanel) setConditions(tableRef?.current?.conditions || [])
        else setConditions([]);
    }, [openPanel]);

    return (
        <SidePanel
            isOpen={openPanel}
            toggle={() => setOpenPanel(!openPanel)}
            sidePanelButtonStyle={"side-panel-button-white"}
        >
            <Grid
                container
                direction='row'
                justifyContent='space-between'
                alignItems='center'
            >
                <Grid item xs={12}>
                    <label style={{ fontSize: 'large', fontWeight: 500 }}>{messages['report_overview_filters']}</label>
                </Grid>
                <Grid item xs={12}>
                    <Form
                        ref={formRef}
                        onValidSubmit={() => {
                            if (props.onValidSubmit) {
                                props.onValidSubmit();
                            }
                        }}
                    >
                        <Grid item xs={12} style={{ marginTop: 10, marginBottom: 10 }}>
                            <CustomSelect
                                async
                                value={account}
                                onChange={(item) => {
                                    setAccount(item);

                                    let currentConditions = conditions.length === 0 ? tableRef?.current?.conditions : conditions;
                                    let newConditions = currentConditions.filter((condition) => condition.fields[0] !== 'accountId');
                                    if (item)
                                        newConditions.push({ fields: ["accountId"], terms: [item?.id], exact: true, conditionOperator: "AND", account: item })

                                    setConditions(newConditions);
                                }}
                                label={messages['devices_bulk_actions_account']}
                                placeholder={messages['devices_bulk_actions_account']}
                                loadOptions={getAccountsForSelect}
                                loading={loadingAccounts}
                                getOptionLabel={e => e.name}
                                getOptionValue={e => e.id}
                            />
                        </Grid>
                        <Grid item xs={12} style={{ marginTop: 10, marginBottom: 10 }}>
                            <label className="input-normal-label" style={{ marginRight: 5 }}>{messages['transactions_requests_date_range']}</label>
                            {
                                openPanel &&
                                <DateRangePicker
                                    calendarPosition="bottom-end"
                                    className=""
                                    startDate={startDate}
                                    endDate={endDate}
                                    format="MMM DD, YYYY"
                                    maxDate={moment.now()}
                                    minDate={getRetentionMinDate()}
                                    onChange={(start, end) => {

                                        setStartDate(start);
                                        setEndDate(end);

                                        let currentConditions = conditions.length === 0 ? tableRef?.current?.conditions : conditions;
                                        let newConditions = currentConditions.filter((item) => !item.range);

                                        if (start && end) {
                                            const gteDate = moment.max(moment(start), getRetentionMinDate());
                                            newConditions.push({
                                                fields: [], terms: [],
                                                range: {
                                                    fields: ["createdOn"],
                                                    GTE: moment(gteDate.format("YYYY-MM-DD") + " 00:00:00").format("YYYY-MM-DDTHH:mm:ss.SSS") + "Z",
                                                    LTE: moment(moment(end).format("YYYY-MM-DD") + " 23:59:59").format("YYYY-MM-DDTHH:mm:ss.SSS") + "Z"
                                                },
                                                exact: true, conditionOperator: "AND"
                                            })
                                        }
                                        tableRef?.current?.getData(null, null, null, newConditions, null, { filterValidation: false });
                                        setConditions(newConditions);

                                    }}
                                    orientation="horizontal"
                                    style={{
                                        width: '100%'
                                    }}
                                    showButtons={true}
                                />
                            }
                        </Grid>
                        <Grid item xs={12} style={{ marginTop: 10, marginBottom: 10 }}>
                            <Button
                                className="btn btn-dark-blue btn-block"
                                onClick={(e) => handleApply()}
                            >
                                {messages['report_overview_execute_report']}
                            </Button>
                        </Grid>
                    </Form>
                </Grid>
            </Grid>
        </SidePanel>
    )
}
export default AdvancedFilters